import { Box, Card, Paragraph, TextButton } from '@zillow/constellation-10';
import { IconExternalFilled } from '@zillow/constellation-icons';
import {
  StyledBrandImage,
  StyledEhoLogo,
  StyledHeaderOverlay,
  StyledLogo,
  StyledSlugOverlay,
} from './StyledComponents';

export interface DfpPreviewInFeedInternal {
  templateValues: Record<string, string>;
}

const getUrlFromTemplateValues = (templateValues: Record<string, string>) => {
  if (templateValues.URLClickthroughZillowWeb) {
    return templateValues.URLClickthroughZillowWeb;
  }

  if (templateValues.UrlClickthroughZillowWeb) {
    return templateValues.UrlClickthroughZillowWeb;
  }

  return '#';
};

// Keep in sync with https://admanager.google.com/7449#creatives/custom_native_style/detail/styleid=272059
export const DfpPreviewInFeedInternal = ({ templateValues }: DfpPreviewInFeedInternal) => {
  const url = getUrlFromTemplateValues(templateValues);

  return (
    <Box className="DfpPreviewInFeedInternal">
      <Box id={`logo${templateValues.ListDisplayLogo}`}>
        <Box className="container">
          <Card css={{ padding: 0 }} elevated={false}>
            <a href={url} target="_blank" rel="noopener noreferrer" id="clickthru" style={{ textDecoration: 'none' }}>
              <StyledBrandImage style={{ backgroundImage: `url(${templateValues.ImageBrandRectangle})` }}>
                <StyledHeaderOverlay>Sponsored</StyledHeaderOverlay>
                <StyledSlugOverlay>{templateValues.ListFlagOptions}</StyledSlugOverlay>
                {templateValues.ListDisplayEHOImage === 'yes' && <StyledEhoLogo />}
              </StyledBrandImage>
              <Box css={{ paddingInline: '300', marginBottom: '300' }}>
                <Paragraph textStyle="body-bold" css={{ marginTop: 'xs' }}>
                  {templateValues.TextHeader}
                </Paragraph>
                <Paragraph textStyle="body-sm">{templateValues.TextSubheader01}</Paragraph>
                <Paragraph textStyle="body-sm">{templateValues.TextSubheader02}</Paragraph>
                <Box css={{ marginTop: 'xs' }}>
                  <TextButton
                    tone="brand"
                    css={{ paddingInline: 0 }}
                    iconPosition="end"
                    textStyle="body-sm"
                    icon={
                      <TextButton.Icon color="black" size={'sm'}>
                        <IconExternalFilled />
                      </TextButton.Icon>
                    }
                    asChild
                  >
                    <span>{templateValues.TextCTA}</span>
                  </TextButton>
                </Box>
              </Box>
              {templateValues.ImageLogo && (
                <StyledLogo>
                  <img id="logoSrc" src={templateValues.ImageLogo} alt="" />
                </StyledLogo>
              )}
            </a>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default DfpPreviewInFeedInternal;
